/** Tag applied to Train Factory submissions until What Finland approves them. */
export const TF_PENDING_TAG = "tf-pending";

export function hasTfPendingTag(tags: unknown): boolean {
  return Array.isArray(tags) && tags.includes(TF_PENDING_TAG);
}
